<script setup lang="ts">
const props = defineProps({
    color: {
        type: String,
        default: 'primary'
    },
    disabled: {
        type: Boolean,
        default: false
    },
    to: {
        type: [String, Object, undefined],
        default: undefined
    }
})

const emits = defineEmits<{
    click: () => void
}>()
</script>
<template>
    <component :is="props.to ? 'router-link' : 'button'" :to="props.to" :class="['z-button', `z-button--${props.color}`, {'z-button--disabled': props.disabled}]" @click="emits('click')" :disabled="props.disabled && !props.to">
        <slot></slot>
    </component>
</template>
<style lang="scss" scoped>
.z-button{
    display: inline-block;
    padding: 0 20px;
    margin-top: 10px;
    border: none;
    border-radius: 17px;
    text-decoration: none;
    cursor: pointer;
    font-size: 14px;
    line-height: 34px;
    font-weight: 400;
    text-align: center;
    transition: background-color .3s, color .3s;
    &:hover{
        filter: brightness(1.1);
    }
    &--primary{
        background-color: #DC0303;
        color: #FFFFFF;
    }
    &--secondary{
        background-color: #FFFFFF;
        color: #FF0000;
        border: 1px solid #FF0000;
    }
    &--disabled{
        opacity: .5;
        cursor: not-allowed;
    }
}

</style>